<template>
  <div class="pay-wrap">
    <VCarousel/>
    <div class="pay-inner">
      <h2>A产品增值服务购买</h2>
      <h3>Purchase of value-added services</h3>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import VCarousel from '@/components/VCarousel.vue'

export default {
  components: {
    VCarousel
  },
  name: 'pay',
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.pay-wrap {
  position: relative;
  .pay-inner {
    max-width: 1024px;
    margin: 0 auto;
    text-align: center;
    padding: 40px 0;
  }
  h2 {
    font-size: 30px;
    color: #000;
    line-height: 42px;
    margin-bottom: 4px;
    margin-top: 8px;
  }
  h3 {
    font-size: 19px;
    color: #000;
    line-height: 26px;
    margin-bottom: 28px;
  }
}
</style>
